import { Loader } from '@googlemaps/js-api-loader'

const loader = new Loader({
	apiKey: "AIzaSyA4wsZBocT2VGPvzgbpXcPQMBtxO8ESye8",
	version: "weekly",
})

export default {
	namespace: 'contact',
	beforeEnter() {

		let allMaps = document.querySelectorAll('.g-map')
		function initMap(mapID, lat, lng, zoom) {
			new google.maps.Map(document.getElementById(mapID), {
				mapId: "8edc5ebe4fa6e631",
				center: { lat: Number(lat), lng: Number(lng) },
				zoom: Number(zoom),
				disableDefaultUI: true,
				gestureHandling: "none",
				zoomControl: false,
			});
		}

		loader
			.load()
			.then((google) => {
				allMaps.forEach(map => {
					let d = map.dataset
					initMap(map.id, d.lat, d.lng, d.zoom)
				})
			})
			.catch(e => {
				// do something
				console.log('error!')
			});

	},
	afterEnter(barba) {
		console.log('View: contact')
	},
	beforeLeave() {

	},
	afterLeave() {

	}
}
